import type { PaymentRequestSourceDocumentKey } from './payment.types';
import { TransactionDetailsTypeId } from './types/transaction-details.enums';

function formatFromSourceDocumentKey(
    sourceDocumentKey: PaymentRequestSourceDocumentKey
): string | undefined {
    switch (sourceDocumentKey.transaction_details_type_id) {
        case TransactionDetailsTypeId.DEALERTRACK_PARTS:
            return sourceDocumentKey.partsInvoiceNumber === undefined
                ? undefined
                : `Invoice # ${sourceDocumentKey.partsInvoiceNumber}`;
        case TransactionDetailsTypeId.DEALERTRACK_SERVICE:
            return sourceDocumentKey.roNumber === undefined
                ? undefined
                : `RO Number ${sourceDocumentKey.roNumber}`;
        case TransactionDetailsTypeId.DEALERTRACK_DEAL:
            return sourceDocumentKey.stockNumber === undefined
                ? undefined
                : `Stock Number ${sourceDocumentKey.stockNumber}`;
        default:
            return undefined;
    }
}

export function formatPaymentRequestSourceDocumentReference(params: {
    sourceDocumentReference?: string;
    sourceDocumentKey?: PaymentRequestSourceDocumentKey;
}): string | undefined {
    if (params.sourceDocumentKey !== undefined) {
        const formatted: string | undefined = formatFromSourceDocumentKey(params.sourceDocumentKey);
        if (formatted !== undefined) {
            return formatted;
        }
    }
    return params.sourceDocumentReference;
}
